import Marquee from "react-fast-marquee";

const items = ["RELATÓRIOS", "ESTOQUE", "GESTÃO", "PDV", "APPS CUSTOM", "AUTOMAÇÃO"];

export const Ribbon = () => (
  <section className="border-y border-white/10 bg-surface/40 overflow-hidden" aria-hidden>
    <div className="h-28 md:h-40 flex items-center overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-head font-black text-5xl md:text-7xl leading-none text-stroke mx-6 md:mx-10">{t}</span>
            <span className="w-3 h-3 md:w-4 md:h-4 bg-acid rotate-45" />
          </div>
        ))}
      </Marquee>
    </div>
  </section>
);
